<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number
  }>(),
  { size: 48 },
)
</script>

<template>
  <svg
    :width="size"
    :height="Math.round(size * (69 / 64))"
    viewBox="0 0 64 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="v-grad" x1="0" y1="0" x2="64" y2="69" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#00a5a6" />
        <stop offset="0.45" stop-color="#009192" />
        <stop offset="1" stop-color="#0074a4" />
      </linearGradient>
      <clipPath id="v-clip">
        <path
          d="M53.296 0a6.834 6.834 0 0 0-6.353 4.318L29.212 44.034 17.438 18.724a8.402 8.402 0 0 0-7.813-5.311H0L23.85 68.784h10.725L63.758 0Z"
        />
      </clipPath>
    </defs>
    <!-- Solid base at low opacity -->
    <rect clip-path="url(#v-clip)" width="64" height="69" fill="url(#v-grad)" opacity="0.15" />
    <!-- Shimmer — angled highlight sweeping via translateX (GPU-composited) -->
    <g clip-path="url(#v-clip)">
      <g class="sweep">
        <rect x="-80" y="-20" width="220" height="110" fill="url(#v-grad)" opacity="0.9" mask="url(#shimmer-mask)" />
      </g>
    </g>
    <defs>
      <mask id="shimmer-mask">
        <!-- Rotated narrow highlight band matching the V angle -->
        <rect
          x="10"
          y="-40"
          width="12"
          height="150"
          rx="6"
          transform="rotate(23 32 35)"
          fill="white"
          filter="url(#shimmer-blur)"
        />
      </mask>
      <filter id="shimmer-blur">
        <feGaussianBlur stdDeviation="5" />
      </filter>
    </defs>
  </svg>
</template>

<style scoped>
.sweep {
  animation: sweep 1.3s ease-in-out infinite;
  will-change: transform;
}

@keyframes sweep {
  0% {
    transform: translateX(-70px);
  }
  100% {
    transform: translateX(70px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .sweep {
    animation: none;
  }
}
</style>
